import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/backs/57_card_back_umbrellas/57_card_back_umbrellas"
 * Contains 1 texture(s)
 */
export class CardsBacks57CardBackUmbrellasAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/backs/57_card_back_umbrellas/57_card_back_umbrellas';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '57_umbrellas.png'
    ] as const;
}
